import moment from "moment-timezone";
import { toast } from "react-toastify";

const currentTimeZone = moment.tz.guess();
// console.log("🚀 ~ currentTimeZone:", currentTimeZone)

export const convertDateToUTC = (localDate, dayType) => {
  console.log("🚀 ~ convertDateToUTC ~ dayType:", dayType, localDate);
  let utcDate;
  switch (dayType) {
    case "start":
      utcDate = moment(localDate, currentTimeZone)
        .startOf("day")
        .utc()
        .format();
      // console.log("🚀 ~ convertDateToUTC ~ utcDate:", utcDate)
      break;
    case "end":
      utcDate = moment(localDate, currentTimeZone).endOf("day").utc().format();
      break;
    default:
      utcDate = moment(localDate, currentTimeZone).utc().format();
      break;
  }
  return utcDate;
};

export const formatOfDate = (dateObj) => {
  return moment(dateObj).format("YYYY-MM-DD");
};

/**
 * Convert a Date (or date-like) to "YYYY-MM-DD" string.
 * If input is falsy or invalid => returns empty string.
 * @param {Date | string | null | undefined} date
 * @returns {string}
 */
export function formatDateToYYYYMMDD(date) {
  if (!date) return "";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "";
  return moment(d).format("YYYY-MM-DD");
}

/**
 * @param {[Date | null, Date | null]} dateRange
 * @returns {{ startDate: string, endDate: string }}
 */
export function getFormattedRange(dateRange) {
  const [start, end] = dateRange;
  const startDate = formatDateToYYYYMMDD(start);
  const endDate = formatDateToYYYYMMDD(end);

  let finalEnd = endDate;

  if (startDate && endDate && endDate < startDate) {
    // clear end if invalid (end before start)
    finalEnd = "";
  }

  return {
    startDate,
    endDate: finalEnd,
  };
}

export const convertUTCToLocalDate = (utcDate) => {
  const localDate = moment(utcDate).local().format();
  return localDate;
};

export const convertTimeToUTC = (localTime) => {
  const utcTime = moment(localTime, "HH:mm", currentTimeZone).utc().format();
  return utcTime;
};

// export const convertUtcToLocal = (utcTime) => {
//   const currentTimeZone = moment.tz.guess();
//   const timeInZone = moment(utcTime).tz(currentTimeZone).format("hh:mm A");
//   return timeInZone;
// };

export const convertUtcToLocal = (utcTime) => {
  if (!utcTime) return null;

  const currentTimeZone = moment.tz.guess();

  // Add today's date to form a valid datetime string
  const today = moment().format("YYYY-MM-DD");
  const fullTime = `${today}T${utcTime}Z`; // assume input is UTC

  const timeInZone = moment.utc(fullTime).tz(currentTimeZone).format("hh:mm A");
  return timeInZone;
};

// export const convertToLocalTime = (timeStr) => {
//   const dateUTC = new Date(`1970-01-01T${timeStr}Z`);
//   return dateUTC.toLocaleTimeString([], {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: false, // or true for AM/PM format
//   });
// };

export const convertTime = (timeString) => {
  return moment(timeString, "HH:mm:ss").local().format("hh:mm A");
};

export const convertUtcToLocalTo24 = (utcTime) => {
  const currentTimeZone = moment.tz.guess();
  const timeInZone = moment(utcTime).tz(currentTimeZone).format("HH:mm");
  return timeInZone;
};

export const convertDateToUTCWithResetTime = (localDate) => {
  const date = moment(new Date(localDate))
    .startOf("day")
    .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

  return date;
};

/**
 * Converts a JS Date object or valid date string to 'YYYY-MM-DD' format
 * @param {Date|string|null} date - Date object or date string
 * @returns {string|null} Formatted date or null
 */
// export const formatDateToYMD = (date) => {
//   if (!date) return null;

//   const m = moment(date);
//   return m.isValid() ? m.format("YYYY-MM-DD") : null;
// };

// export const formatDateToYMD = (date) => {
//   if (!date) return null;
//   return moment(date).utc().format("YYYY-MM-DD");
// };

export const formatDateToYMD = (date) => {
  if (!date) return null;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// 2025-07-11T19:00:00.000Z -> YYYY-MM-DD
export const formatDate = (dateString) => {
  if (!dateString) return null;
  return moment.utc(dateString).format("YYYY-MM-DD");
};
// 2025-07-11T19:00:00.000Z ->  Output: "11 Jul, 2025" (in local timezone)
// export const formatDateToLocal = (dateString) => {
//   return moment(dateString).local().format("DD MMMM, YYYY");
// };

// Fix timezone issue: parse as local datetime, use local date parts
// export function formatDateToLocal(dateStr) {
//   if (!dateStr) return "-";

//   const d = new Date(dateStr);
//   if (isNaN(d.getTime())) return "-";

//   // Use local date parts so "2026-02-17T19:00:00.000Z" (midnight PKT) shows Feb 18
//   const local = new Date(d.getFullYear(), d.getMonth(), d.getDate());

//   return local.toLocaleDateString("en-US", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// }

// export function formatDateToLocal(dateStr) {
//   if (!dateStr) return "-";

//   // Ab hamesha "2026-04-15" format aayega
//   const [year, month, day] = dateStr.split("-");
//   const local = new Date(year, month - 1, day); // ✅ No timezone issue

//   return local.toLocaleDateString("en-US", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// }
export function formatDateToLocal(dateStr) {
  if (!dateStr) return "-";

  let year, month, day;

  // Format 1: "2026-04-15T19:00:00.000Z" (datetime)
  if (dateStr.includes("T")) {
    const datePart = dateStr.split("T")[0]; // "2026-04-15" lo, time ignore
    [year, month, day] = datePart.split("-");
  }
  // Format 2: "2026-04-15" (sirf date)
  else {
    [year, month, day] = dateStr.split("-");
  }

  const local = new Date(year, month - 1, day); // ✅ No timezone issue
  if (isNaN(local.getTime())) return "-";

  return local.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export const capitalizeFirstLetter = (string) => {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return "";
  }
};

export const lowercaseFirstLetter = (string) => {
  if (string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  } else {
    return "";
  }
};

export const capitalizeString = (str) => {
  return str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};

export const capitalizeFirstLetter2 = (str) => {
  const spaced = str.replace(/([A-Z])/g, " $1").trim();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const timeAgo = (utcDate) => {
  if (!utcDate) return "";

  // Support both ISO and 'YYYY-MM-DD HH:mm:ss' as UTC
  const date = moment
    .utc(utcDate, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss"])
    .local();
  const now = moment();

  if (date.isAfter(now)) {
    return date.format("DD MMM, YYYY hh:mm A");
  }

  const diff = moment.duration(now.diff(date));
  const days = Math.floor(diff.asDays());
  const hours = Math.floor(diff.asHours()) % 24;
  const minutes = Math.floor(diff.asMinutes()) % 60;
  const seconds = Math.floor(diff.asSeconds()) % 60;

  const parts = [];
  if (days > 0) parts.push(`${days} day${days !== 1 ? "s" : ""}`);
  if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
  if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
  if (parts.length === 0 && seconds >= 0) {
    parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);
  }

  return `${parts.join(", ")} ago`;
};

// helper: "HH:MM" -> minutes
export const toMinutes = (t = "") => {
  if (!t) return NaN;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export const handleApiError = (error) => {
  // Network error (Failed to fetch)
  if (error?.status === "FETCH_ERROR") {
    toast.error("Server not reachable. Please check your internet.");
    return;
  }

  // Backend error with message
  if (error?.data?.message) {
    toast.error(error.data.message);
    return;
  }

  // Validation errors (Laravel / Node etc)
  if (error?.data?.errors) {
    const firstError = Object.values(error.data.errors)[0][0];
    toast.error(firstError);
    return;
  }

  // Fallback
  toast.error("Something went wrong");
};
